<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">

            <section class="l-content-area">
                <div class="l-content">

                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_REGISTER_ACCOUNT') }}</h1>
                                    </div>

                                    <!-- register -->
                                    <section class="p-register">

                                        <div class="p-register__finish">
                                            <h2>{{ $t('TEXT_EDIT_ACCOUNT_FINISH_1') }}</h2>
                                            <p>{{ $t('TEXT_EDIT_ACCOUNT_FINISH_2') }}</p>
                                            <div class="c-btn c-btn--tologin"><button @click="goToToppage">{{ $t('LABEL_BUTTON_TOP_PAGE') }}</button></div>
                                        </div>

                                    </section><!-- .p-register -->

                                </div><!-- .bg-box -->

                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>
</template>
<script setup>
import { useSessionStore } from "@/stores/sessionStore";
import {useUserStore} from "@/stores/userStore";
import router from "@/router";

const sessionStore = useSessionStore();
const userStore = useUserStore();

async function goToToppage() {
    await userStore.getAccountInfo();
    sessionStore.session_data.last_name = userStore.editAccountParams.last_name;
    sessionStore.session_data.first_name = userStore.editAccountParams.first_name;
    userStore._isValidUserInfo = true;
    await router.push({ name: "top.page" });
}
</script>